import { CSSObject, css } from '@emotion/react'
import {
  Spacing,
  Typography,
  Shadow,
  ShadowElevation,
  gemVar,
  ThemedColors,
  CornerRadius,
} from '@opallabs/gem'
import { menuOptionSelectors } from '@opallabs/lapidary'

const MAX_HEIGHT = 272

export const container = css({
  position: 'relative',
})

export const list: CSSObject = {
  borderRadius: CornerRadius.Small,
  display: 'flex',
  flexFlow: 'column nowrap',
  inlineSize: '100%',
  margin: 0,
  maxBlockSize: MAX_HEIGHT,
  overflow: 'auto',
  padding: Spacing.XS,
  position: 'absolute',
  rowGap: Spacing.XS,
  zIndex: 2,
  backgroundColor: gemVar(ThemedColors.Surface1),
  ...Shadow[ShadowElevation.E2],
}

export const emptySearch: CSSObject = {
  ...Typography.T500,
  paddingBlock: 6,
  paddingInline: 8,
  textAlign: 'center',
  color: gemVar(ThemedColors.TextSecondary),
}

export const loaderListItem = css({
  display: 'block',
  paddingBlock: 6,
  paddingInline: 8,
  position: 'relative',
})

export const menuOption: CSSObject = {
  [`.${menuOptionSelectors.menuOptionTrailingText}`]: {
    color: gemVar(ThemedColors.TextSecondary),
  },
}

export const menuOptionText: CSSObject = {
  columnGap: 4,
  display: 'flex',
  [`&:has(+ .${menuOptionSelectors.menuOptionTrailingText})`]: {
    flexGrow: 1,
    flexShrink: 0,
    maxInlineSize: 'unset',
  },
}
